module.exports = __webpack_public_path__ + "static/media/btn-close-x.40f216a2.svg";